import React, { useState } from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';

import { Field, Form } from 'react-final-form';
import { Col } from 'reactstrap';
import renderDropZoneMultipleField from '@/shared/components/form/DropZoneMultiple';

import axios from 'axios';

import { fetchEventIcons } from '@/services/events/fetchEventIcons';

import {useDispatch, flashError, flashSuccess} from "@/shared/components/flash"

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

const IconUpload = ({ setIcons, toggle, onCancel, program }) => {

  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  function handleUpload(values){

    let data = new FormData();
    
    if(!values.files){
        return
    }

    values.files.forEach(element => {
        data.append('image[]', element)
    });
    setLoading(true)
    axios
    .post(`/organization/${program.organization_id}/event_icons`, data,
      {
        headers: {
            "Content-type": "multipart/form-data",
        },
      }
    )
    .then((res) => {
      if (res.status == 200) { //fetch all on success!
        flashSuccess(dispatch, "Icon uploaded!")
        fetchEventIcons(program.organization_id, 'both')
        .then( response => {
            setIcons(response)
        })
      }
    })
    .catch((error) => {
      flashError(dispatch, error.response.data)
      setLoading(false);
    });
  }
  
  async function onSubmit (files){
    handleUpload(files);
    await sleep(800);
    toggle('2');
  }

  return (
    <Col md={12} lg={12} className="dropzone-iconupload manager-program-settings-picker__pane">
      <Form onSubmit={onSubmit}>
        {({ handleSubmit }) => (
          <form className="form manager-program-settings-picker__form" onSubmit={handleSubmit}>
            <p className="manager-program-settings-picker__copy">
              Use `jpg`, `jpeg`, `gif`, `png`, or `ico` files up to 5 MB.
            </p>

            <Field
              name="files"
              component={renderDropZoneMultipleField}
            />
            <div className="manager-program-settings-dialog__actions">
              <button
                type="submit"
                className="manager-program-settings-dialog__action is-primary"
                disabled={loading}
              >
                Upload
              </button>
              <button
                type="button"
                className="manager-program-settings-dialog__action"
                onClick={onCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      </Form>
    </Col>
  );
};

IconUpload.propTypes = {
  setIcons: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  program: PropTypes.object.isRequired,
};
export default connect((state) => ({
  program: state.program
}))(IconUpload);
